import Vue from 'vue'
import Index from './index.vue'
const Constructor = Vue.extend(Index)

let nId = 1

const FContactUs = () => {
  const instance = new Constructor()
  instance.id = 'contact-us-' + nId++
  instance.dialogVisible = true
  instance.$mount()
  document.body.appendChild(instance.$el)
  return instance
}

export default {
  install: Vue => {
    Vue.prototype.$contactus = FContactUs
  }
}
